export default __webpack_public_path__ + "static/media/darkTailgating.89289701.png";